module.exports = __webpack_public_path__ + "img/frites.049d584c.png";